import React, { useContext } from 'react';
import {
  MedioComposableBanner as MedioComposableBannerComponent
} from '@thd-olt-component-react/internal-marketing-banner';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { string } from 'prop-types';
import { HomepageContext } from './context/HomepageContext';

export function MedioComposableBanner({ id }) {
  const { isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="internal-marketing-banner-medio-composable">
      <QueryProvider key={id} cacheKey={id}>
        <MedioComposableBannerComponent
          componentId={id}
          componentClass="MedioComposableBanner"
          enableB2CRadius={isB2C}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

MedioComposableBanner.propTypes = {
  id: string.isRequired
};

MedioComposableBanner.defaultProps = {};
